import React from "react";
import { cn } from "../lib/utils";

export const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & {
    variant: "info" | "success" | "error";
  }
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(
      "gap-bb relative flex w-full items-start rounded-md p-4 [&>svg]:!size-[1lh] [&>svg]:flex-shrink-0",
      {
        "bg-bg-light-blue text-black [&>svg]:text-black": variant === "info",
        "bg-bg-green text-green-4 [&>svg]:text-green-4": variant === "success",
        "bg-bg-pink text-error [&>svg]:text-error": variant === "error",
      },
      className,
    )}
    {...props}
  />
));
Alert.displayName = "Alert";

export const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("bb-text-tiny text-pretty", className)}
    {...props}
  />
));
AlertDescription.displayName = "AlertDescription";
